import { Search, Hammer, Compass, Wrench } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

const icons = [Search, Hammer, Compass, Wrench];

export default function HowWeWork() {
  const t = useT();
  return (
    <section id="how" className="py-24 sm:py-28 border-t border-ink-800/60">
      <div className="container-page">
        <SectionHeading eyebrow={t.howWeWork.eyebrow} title={t.howWeWork.title} lede={t.howWeWork.lede} />
        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {t.howWeWork.items.map((m, i) => {
            const Icon = icons[i] ?? Search;
            return (
              <div
                key={m.title}
                className="rounded-xl border border-ink-800 bg-ink-900/40 p-6 transition hover:border-ink-700 hover:bg-ink-900/70"
              >
                <Icon className="size-6 text-accent-500" />
                <h3 className="mt-4 text-lg font-semibold text-ink-50">{m.title}</h3>
                <p className="mt-2 text-sm text-ink-300 leading-relaxed">{m.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
